import { render, staticRenderFns } from "./SectionSubSubQuiz.vue?vue&type=template&id=194bc08f&scoped=true&"
import script from "./SectionSubSubQuiz.vue?vue&type=script&lang=js&"
export * from "./SectionSubSubQuiz.vue?vue&type=script&lang=js&"
import style0 from "./SectionSubSubQuiz.vue?vue&type=style&index=0&id=194bc08f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194bc08f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('194bc08f')) {
      api.createRecord('194bc08f', component.options)
    } else {
      api.reload('194bc08f', component.options)
    }
    module.hot.accept("./SectionSubSubQuiz.vue?vue&type=template&id=194bc08f&scoped=true&", function () {
      api.rerender('194bc08f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/albert/albertactionplan/SectionSubSubQuiz.vue"
export default component.exports